module.exports = __webpack_public_path__ + "img/Glowkit-poster.2e619e47.jpg";